module.exports = __webpack_public_path__ + "media/faucet_low.f9b3cc8e.mp4";